import { Global_var } from '../global/global_var';
import RestDataSource from './restdatasource';
import { LoginService } from './login.service';

export const PaymentService = {
    Makepayment,
    OfflinePayment
};

function Makepayment(payobject, fn, fnError) {
    LoginService.TokenUser(res => {
        if (res.status === 'success') {

            localStorage.setItem('jwt-token', res.responseObject);
            //var url = "http://192.168.10.103:8062" + Global_var.URL_DO_Payment;
            var url = Global_var.BASEURL + Global_var.URL_DO_Payment;
            // var url = Global_var.TEST_BASEURL + Global_var.URL_DO_Payment;

            //var mobilevalidat = JSON.stringify(ProductByName);
            return new RestDataSource(url, fnError).Store(payobject, (res) => {
                if (res != null) {
                    if (res.headers["jtitoken"] != null) {
                        localStorage.setItem('jti-token', res.headers.jtitoken);
                    }
                    fn(res);
                }
            });
        }
    }, fnError);

}

function OfflinePayment(payobject, fn, fnError) {
    LoginService.TokenUser(res => {
        if (res.status === 'success') {
            localStorage.setItem('jwt-token', res.responseObject);
            var url = Global_var.BASEURL + Global_var.URL_OFFLINE_PAYMENT;

            return new RestDataSource(url, fnError).Store(payobject, (res) => {
                if (res != null) {
                    if (res.headers["jtitoken"] != null) {
                        localStorage.setItem('jti-token', res.headers.jtitoken);
                    }
                    fn(res.data);
                }
            });
        }
    }, fnError);

}





